import React from 'react';

/**
 * Isolates a crash in one routed screen so the rest of the app (layout, menu,
 * other modules) keeps working. Reset by changing `resetKey` (e.g. the route path).
 */
export default class ModuleErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ModuleErrorBoundary] Screen crashed:', error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="lis-module-error" role="alert">
        <div className="lis-module-error-icon" aria-hidden="true">⚠</div>
        <h2>This screen could not be displayed</h2>
        <p>An unexpected error occurred while rendering this module. Other modules are not affected.</p>
        <button type="button" className="btn btn-primary" onClick={() => this.setState({ error: null })}>
          Retry
        </button>
      </div>
    );
  }
}
